import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resume-tab',
  templateUrl: './resume-tab.component.html',
  styleUrls: ['./resume-tab.component.css']
})
export class ResumeTabComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
